document.addEventListener("DOMContentLoaded", (event) => {
  // don't open overlay w/ modal
  var modalElement = document.querySelectorAll(".wf-large-slider .modal");
  modalElement.forEach((el) => {
    el.addEventListener("show.bs.modal", function () {
      document.body.classList.add("hide-modal-backdrop");
      document
        .querySelectorAll(".wf-large-slider .slide-wrap")
        .forEach((el) => {
          el.classList.add("modal-open");
        });
    });
    el.addEventListener("hidden.bs.modal", function () {
      document.body.classList.remove("hide-modal-backdrop");
      document
        .querySelectorAll(".wf-large-slider .slide-wrap")
        .forEach((el) => {
          el.classList.remove("modal-open");
        });
    });
  });
});
